module.exports = __webpack_public_path__ + "img/quicklink-tiles-honda.facee4b1.png";